import { Injectable, inject } from '@angular/core';
import {TenantService} from './tenant.service';
import {Author} from '../models/author.model';
import {from, Observable} from 'rxjs';
import {readCollectionWithIds} from '../common/firestore-utils';
import {first} from 'rxjs/operators';
import { collection, collectionData, doc, Firestore, setDoc } from '@angular/fire/firestore';


@Injectable({
  providedIn: "root"
})
export class AuthorsDbService {
  private tenant = inject(TenantService);
  private firestore = inject(Firestore);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

  }


  createNewAuthor(author: Partial<Author>): Observable<any> {

    const newAuthor = {...author};

    const id = newAuthor.id;
    delete newAuthor.id;

    const createNewAuthorDocRef = doc(this.firestore,`schools/${this.tenant.id}/authors/${id}`)
    const createNewAuthorAsync = setDoc(createNewAuthorDocRef, newAuthor, {merge:true})

    return from(createNewAuthorAsync);

  }


  loadAllAuthors():Observable<Author[]> {
    const loadAllAuthorsData$ = collectionData(collection(this.firestore, `schools/${this.tenant.id}/authors`), {idField: "id"})

    return readCollectionWithIds<Author[]>(loadAllAuthorsData$).pipe(first());

  }
}
